import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WcGridComponent } from './wc-grid.component';
import { WcFilterBuilderComponent } from './wc-filter-builder.component';
import { WcLookupEditorComponent } from './wc-lookup-editor.component';
import { WcColumnChooserComponent } from './wc-column-chooser.component';
import { WcRecordEditorComponent } from './wc-record-editor.component';
import { WcGridPopupComponent } from './wc-grid-popup/wc-grid-popup.component';

@NgModule({
  declarations: [
    WcGridComponent,
    WcFilterBuilderComponent,
    WcLookupEditorComponent,
    WcColumnChooserComponent,
    WcRecordEditorComponent,
    WcGridPopupComponent,
  ],
  imports: [CommonModule, FormsModule],
  exports: [
    WcGridComponent,
    WcFilterBuilderComponent,
    WcLookupEditorComponent,
    WcColumnChooserComponent,
    WcRecordEditorComponent,
    WcGridPopupComponent,
  ],
})
export class WcGridModule {}
